// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56619197","455":"1dbbbf64","977":"72e3425a"}[chunkId] + ".chunk.js";
};